/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "./ColorsProvider";
import type { StylesObject } from "./utils/prefixStyles";

type Props = {
  children?: ?React.Node,
  style?: ?StylesObject,
  colors: ColorSet,
};

class Badge extends React.Component<Props> {
  render() {
    const { children, style, colors } = this.props;

    const styles = {
      root: {
        width: "2em",
        lineHeight: "2em",
        color: colors.PRIMARY_TEXT,
        backgroundColor: colors.TEXT_SECONDARY,
        zIndex: 1,
        borderRadius: "50%",
        position: "absolute",
        right: "-5px",
        top: "-5px",
        textAlign: "center",
        ...style,
      },
    };

    return (
      <div style={styles.root} aria-hidden>
        {children}
      </div>
    );
  }
}

export default withColorsProvider(Badge);



// WEBPACK FOOTER //
// ../nx-components/src/Badge.jsx